import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  Attachment
} from "common-lib";
import {AttachmentsListPage} from "../../pages/attachments/attachments/attachments-list.page";

@Component({
    selector: 'attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrls: ['./attachment-list.component.scss'],
    standalone: false
})
export class AttachmentListComponent implements OnInit, OnDestroy, OnChanges {

  @Input('attachments') attachments: Attachment[];
  @Input('newAttachments') newAttachments: File[];
  @Input('moduleEntityId') moduleEntityId: number;
  @Output('onAttachmentClicked') onAttachmentClicked = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
    console.log("AttachmentListComponent.ngOnInit");
    console.log(this.attachments);
  }

  attachmentClicked(attachment: any) {
    this.onAttachmentClicked.emit({attachment: attachment, moduleEntityId: this.moduleEntityId});
  }

  newAttachmentClicked(newAttachment: any) {
    this.onAttachmentClicked.emit({newAttachment});
  }

  ngOnDestroy(): void {
  }

  isImage(attachment): boolean {
    return attachment.attachmentType.type === 'image';
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("AttachmentListComponent.ngOnChanges");
    console.log(changes);
  }
}
